import { render, staticRenderFns } from "./Submit.vue?vue&type=template&id=2e9ac94f&"
import script from "./Submit.vue?vue&type=script&lang=js&"
export * from "./Submit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/vhosts/lifecheq/htdocs/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2e9ac94f')) {
      api.createRecord('2e9ac94f', component.options)
    } else {
      api.reload('2e9ac94f', component.options)
    }
    module.hot.accept("./Submit.vue?vue&type=template&id=2e9ac94f&", function () {
      api.rerender('2e9ac94f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/views/Leads/Submit.vue"
export default component.exports